import React, { useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Empty from "../Layout/icon/Empty.png";
import { MdDeleteForever, MdDeleteSweep } from "react-icons/md";
import { linkImagesToProduct } from "../auth/apiProduct";
import { language } from "../pageInside/dataElakay";
import ShowimagesLoading from "./showImagesLoading";
import "./LinkImagesTofilterPro.css";
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["linkImagesTofilterPro"]?.[key] || fallback;

// ========== PRESERVED UTILITY FUNCTIONS (EXACT COPY) ==========
const getFiels = (a, b) => {
    var c = [];
    if (a?.length > 0) {
        for (var i = 0; i < a?.length; i++)
            if (!c.includes(a[i][b])) {
                c.push(a[i][b]);
            }
    }
    return c;
};

const objToArr = (a) => {
    return a && { v: Object.values(a), k: Object.keys(a) };
};

function isObjectNullOrEmpty(obj) {
    if (obj === null || obj === undefined) {
        return true;
    }

    if (typeof obj === 'object' && !Array.isArray(obj)) {
        return Object.keys(obj)?.length === 0;
    }

    if (Array.isArray(obj)) {
        return obj?.length === 0;
    }

    return false;
}

// ========== MAIN COMPONENT ==========
const LinkImagesTofilterPro = props => {
    const [filterItem, setFilterItem] = useState({});
    const [firterName, setfirterName] = useState('');

    const {
        loadProductsView,
        laguangeElakay,
        infoSource,
        filtersProduct = [],
        setImagesSMS,
        imagesSms,
        imagesArray,
        setImagesArray,
        filterSel = [],
        productID,
        token,
        prodGaleries = [],
    } = props;
    __setElakayInfoSource(infoSource);

    // ========== PRESERVED HANDLERS (EXACT COPY) ==========
    const handleChange = event => {
        setfirterName(event.target.value);
    };

    const deleteImgArr = (b) => {
        setImagesArray(imagesArray.filter(item => item !== b));
        setImagesSMS("");
    };

    function handleSubmit(queryDel = {}) {
        linkImagesToProduct(token, productID, { name: firterName, images: imagesArray }, queryDel).then(data => {
            if (data.error) {
            } else {
                loadProductsView(productID);
                setImagesArray([]);
                setfirterName('');
            }
        });
    }

    const handleSubDel = (obj, queryDel) => {
        linkImagesToProduct(token, productID, obj, queryDel).then(data => {
            if (data.error) {
            } else {
                loadProductsView(productID);
                setImagesArray([]);
                setfirterName('');
            }
        });
    };

    // ========== PRESERVED VIEW FUNCTIONS (EXACT COPY WITH MODERN WRAPPER) ==========
    const formImages = (objArr) => (
        <div className="images-gallery-section">
            <div className="gallery-container">
                <h4 className="gallery-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).linkImagesTofilterPro.t001}</h4>

                {objArr?.map((pg, j) => (
                    <div key={j} className="gallery-group">
                        <div className="gallery-group-header">
                            <h6 className="gallery-group-title">
                                <span className="delete-group-btn" onClick={() => handleSubDel(pg, { SPA: true })}>
                                    <MdDeleteSweep />
                                </span>
                                {pg.name ? pg.name.charAt(0).toUpperCase() + pg.name.slice(1) : elakayAutoText("h_linkimages_untitled_group", "Images")}
                            </h6>
                        </div>

                        <Row xs={3} md={5}>
                            {pg.images?.map((nm, i) => (
                                <Col key={i}>
                                    <div className="gallery-image-wrapper">
                                        <div className="gallery-image-item">
                                            <ShowimagesLoading
                                                src={nm}
                                                alt={nm}
                                                style={{ maxHeight: "100%", maxWidth: "100%" }}
                                            />
                                            <div className="image-delete-overlay">
                                                <MdDeleteForever
                                                    onClick={() => handleSubDel(pg, { SPO: true, I: i })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}

                {imagesSms && <p className="success-message">{imagesSms}</p>}
            </div>
        </div>
    );

    const selectFilter = () => {
        return (
            <div className="filter-selector-section">
                {!isObjectNullOrEmpty(filterItem) ? (
                    <>
                        <h5 className="filter-selected-title">{filterItem._id.name}</h5>
                        <div className="radio-group-modern">
                            {filterItem.FilterItem?.length > 0 ?
                                filterItem.FilterItem?.map((k, i) => (
                                    <div key={i} className="radio-item-modern">
                                        <input
                                            onChange={handleChange}
                                            value={k}
                                            name={filterItem._id.name}
                                            type="radio"
                                            checked={firterName === k ? 'checked' : ""}
                                            className="radio-input-modern"
                                            id={i + "_" + k}
                                        />
                                        <label className="radio-label-modern" htmlFor={i + "_" + k}>
                                            {k}
                                        </label>
                                    </div>
                                )) :
                                filterItem._id.FilterItem?.map((k, i) => (
                                    <div key={i} className="radio-item-modern">
                                        <input
                                            onChange={handleChange}
                                            value={k}
                                            checked={firterName === k ? 'checked' : ""}
                                            name={filterItem._id.name}
                                            type="radio"
                                            className="radio-input-modern"
                                            id={i + "_" + k}
                                        />
                                        <label className="radio-label-modern" htmlFor={i + "_" + k}>
                                            {k}
                                        </label>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                ) : (
                    <>
                        <div className="filter-list-modern">
                            {filterSel && filterSel?.map((c, i) => (
                                <div
                                    key={i}
                                    className="filter-list-item"
                                    onClick={() => setFilterItem(c)}
                                >
                                    {c._id.name}
                                </div>
                            ))}
                        </div>

                        <div className="radio-item-modern">
                            <input
                                onChange={handleChange}
                                value={elakayAutoText("h_d53641f45c653a", "all Filter")}
                                name={elakayAutoText("h_99fb94896ed049", "filterItem._id.name")}
                                type="radio"
                                checked={firterName === "all Filter" ? 'checked' : ""}
                                className="radio-input-modern"
                                id={elakayAutoText("h_b9d8eb1ee1f520", "allFilIt_")}
                            />
                            <label className="radio-label-modern" htmlFor={elakayAutoText("h_b9d8eb1ee1f520", "allFilIt_")}>
                                {language(infoSource, "label", "allFilIt")}
                            </label>
                        </div>
                    </>
                )}
            </div>
        );
    };

    const imagesSelected = (a) => {
        return (
            <div className="selected-images-section">
                {a?.length > 0 ? (
                    <>
                        <h6 className="selected-images-title">
                            {!isObjectNullOrEmpty(filterItem) ? filterItem._id.name : elakayAutoText("h_ea799bdae3ae9f", "No filter")}:{' '}
                            <span className="filter-name-highlight">{firterName}</span>
                            {' '}
                            {language(infoSource, "label", "lithImg")}
                        </h6>
                        <Row xs={3} md={3}>
                            {a && a?.map((nm, i) => (
                                <Col key={i}>
                                    <div className="selected-image-wrapper">
                                        <ShowimagesLoading
                                            src={nm}
                                            alt={nm}
                                            style={{ maxHeight: "100%", maxWidth: "100%" }}
                                        />
                                        <div className="image-delete-overlay">
                                            <MdDeleteForever onClick={() => deleteImgArr(nm)} />
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </>
                ) : (
                    <div className="empty-state">
                        <h6 className="empty-state-title">
                            {language(infoSource, "label", "ImgLinFil")}
                        </h6>
                        <img
                            src={Empty}
                            alt={__elakayText("t002", "empty images")}
                            className="empty-state-image"
                        />
                    </div>
                )}
            </div>
        );
    };

    const selectFomr = () => {
        return (
            <div className="link-images-modern">
                <div className="link-images-content">
                    {/* Filter Selection & Selected Images */}
                    <div className="selection-section">
                        {filterSel?.length > 0 ? (
                            <div className="selection-grid">
                                {/* Left: Filter Selector */}
                                <div className="filter-column">
                                    {selectFilter()}
                                    <button
                                        type="button"
                                        className="btn-clear-modern"
                                        onClick={() => { setFilterItem({}); setfirterName(""); }}
                                    >
                                        {language(infoSource, "Button", "clear")}
                                    </button>
                                </div>

                                {/* Right: Selected Images */}
                                <div className="images-column">
                                    {imagesSelected(imagesArray)}

                                    {imagesArray?.length > 0 && firterName ? (
                                        <button
                                            className="btn-submit-modern"
                                            onClick={handleSubmit}
                                        >
                                            {infoSource.language(infoSource, 'Button', "submit")}
                                        </button>
                                    ) : (
                                        <button
                                            className="btn-submit-modern disabled"
                                            disabled
                                        >
                                            {infoSource.language(infoSource, 'Button', "submit")}
                                        </button>
                                    )}

                                    {imagesSms && <p className="success-message">{imagesSms}</p>}
                                </div>
                            </div>
                        ) : (
                            <div className="no-filters-state">
                                <h2 className="no-filters-title">
                                    {language(infoSource, "label", "canLinImgFil")}
                                </h2>
                                <h6 className="no-filters-subtitle">
                                    {language(infoSource, "label", "filPreAddYet")}
                                </h6>
                            </div>
                        )}
                    </div>

                    {/* Gallery Section */}
                    <div className="gallery-section">
                        {formImages(prodGaleries)}
                    </div>
                </div>
            </div>
        );
    };

    return selectFomr();
};

export default LinkImagesTofilterPro;